/**
 * The medication and payment frequency recommended from the interview answers.
 *
 * /result renders entirely from its query params and defaults `frequency` but
 * not `medication` — hand it a missing medication and the plan filter matches
 * nothing, leaving a blank pricing page. resultPath() therefore defaults both,
 * so no funnel step can navigate there with an incomplete pair.
 */

const MEDICATION_BY_PRIORITY = {
    affordability: 'semaglutide',
    speed: 'tirzepatide',
    results: 'tirzepatide'
};

export const DEFAULT_MEDICATION = 'semaglutide';
export const DEFAULT_FREQUENCY = 'threeMonths';

export function recommendationFor(priority) {
    return {
        medication: MEDICATION_BY_PRIORITY[priority] ?? DEFAULT_MEDICATION,
        frequency: DEFAULT_FREQUENCY
    };
}

export function resultPath({ medication, frequency } = {}) {
    const chosenMedication = medication ?? DEFAULT_MEDICATION;
    const chosenFrequency = frequency ?? DEFAULT_FREQUENCY;

    return `/result?medication=${chosenMedication}&frequency=${chosenFrequency}`;
}
